import { render, staticRenderFns } from "./AddDoctor.vue?vue&type=template&id=67f0ef84"
import script from "./AddDoctor.vue?vue&type=script&lang=js"
export * from "./AddDoctor.vue?vue&type=script&lang=js"
import style0 from "./AddDoctor.vue?vue&type=style&index=0&id=67f0ef84&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports